// Module
var code = "<div class=\"row\"> <div class=\"col-12\"> <h4>Not found</h4> </div> </div> <div class=\"row\"> <div class=\"col-lg-12\"> <p style=\"text-align:center\">We apologise but we couldn't find the organization you were looking for.</p> </div> </div> ";
// Exports
module.exports = code;